import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #bbbbbb;
  border-radius: 16px;
  width: fit-content;
`;

export const GlobalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #464646;
  font-size: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CurrencyButton = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  border: 1px solid #616161;
  border-radius: 8px;
  background: ${({ $selected }) => ($selected ? '#BBBBBB' : '#FFFFFF')};
  cursor: pointer;
  font-family: 'Work Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  transition: all 0.15s ease;
  box-shadow: ${({ $selected }) =>
    $selected
      ? '0px 0px 0px 4px rgba(152, 162, 179, 0.14), inset 0px 0px 2px 1px rgba(16, 24, 40, 0.08), inset 0px 0px 3px 1px rgba(16, 24, 40, 0.12)'
      : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'};

  &:hover {
    background: ${({ $selected }) => ($selected ? '#BBBBBB' : '#F5F5F5')};
  }

  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px 4px rgba(152, 162, 179, 0.14), inset 0px 0px 2px 1px rgba(16, 24, 40, 0.08),
      inset 0px 0px 3px 1px rgba(16, 24, 40, 0.12);
  }
`;

export const FlagWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;
